const doc = [({"en":({"js":({"admin":({"contacts":({"show":({"realtions":({"add_a_contact":"Add a contact"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;